// Class: motion.easing._Cubic.CubicEaseOut

var $global = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : this

$global.Object.defineProperty(exports, "__esModule", {value: true});

var __map_reserved = {};

// Imports

var $hxClasses = require("./../../../hxClasses_stub").default;
function motion_easing_IEasing() {return require("./../../../motion/easing/IEasing");}

// Constructor

var CubicEaseOut = function() {
}

// Meta

CubicEaseOut.__name__ = ["motion","easing","_Cubic","CubicEaseOut"];
CubicEaseOut.__isInterface__ = false;
CubicEaseOut.__interfaces__ = [(motion_easing_IEasing().default)];
CubicEaseOut.prototype = {
	calculate: function(k) {
		return --k * k * k + 1;
	},
	ease: function(t,b,c,d) {
		t = t / d - 1;
		return c * (t * t * t + 1) + b;
	}
};
CubicEaseOut.prototype.__class__ = CubicEaseOut.prototype.constructor = $hxClasses["motion.easing._Cubic.CubicEaseOut"] = CubicEaseOut;

// Init



// Statics




// Export

exports.default = CubicEaseOut;